exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout_from_Layout-css_7ks {\n\n}\n\n.content_from_Layout-css_2I- {\n  padding-top: 60px;\n}\n", ""]);

// exports
exports.locals = {
	"layout": "layout_from_Layout-css_7ks",
	"content": "content_from_Layout-css_2I-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/layout/Layout.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Layout.css
// module chunks = 0